import React, { useState } from "react";
import PropTypes from "prop-types";
import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";
import { theme } from "../../../../theme";
import "./ChoosePackage.scss";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";

const ChoosePackage = ({ selectedPackage, setSelectedPackage, onetime, tierPrices, isSubscription, setIsSubscription }) => {


    const oneTimePackages = [
        {
            id: "one-time-450",
            name: "One-Time",
            description: "Perfect for a single property valuation",
            price: onetime,
            type: "one-time",
        },
    ];

    const subscriptionPackages = [
        {
            id: tierPrices[0]?.price_id,
            name: "Basic",
            price: tierPrices[0]?.amount,
            period: "per month",
            description: tierPrices[0]?.description,
            type: "subscription",
            popular: false,
        },
        {
            id: tierPrices[1]?.price_id,
            name: "Business",
            price: tierPrices[1]?.amount,
            period: "per month",
            description: tierPrices[1]?.description,
            type: "subscription",
            popular: true,
        },
        {
            id: tierPrices[2]?.price_id,
            name: "Enterprise",
            price: tierPrices[2]?.amount,
            period: "per month",
            description: tierPrices[2]?.description,
            type: "subscription",
            popular: false,
        },
    ];

    const currentPackages = isSubscription
        ? subscriptionPackages
        : oneTimePackages;

    const handlePackageChange = (event) => {
        const packageId = event.target.value;
        const selectedPkg = currentPackages.find((pkg) => pkg.id === packageId);
        setSelectedPackage?.(selectedPkg);
    };

    const handleToggleClick = (subscriptionMode) => {
        setIsSubscription(subscriptionMode);
        setSelectedPackage?.(null);
    };

    const SubscriptionCard = (pkg) => (
        <div
            key={pkg.id}
            className={`subscription-card ${selectedPackage?.id === pkg.id ? "selected" : ""
                }`}
        >
            <div className="card-header">
                <FormControlLabel
                    value={pkg.id}
                    control={
                        <Radio
                            sx={{
                                color: "#d1d5db",
                                "&.Mui-checked": {
                                    color: theme.palette.primary.main,
                                },
                            }}
                        />
                    }
                    label=""
                    className="package-radio"
                />
            </div>

            <div className="subscription-content">
                <div
                    className={`subscription-header ${selectedPackage?.id === pkg.id ? "selected" : ""
                        }`}
                >
                    <Typography className="subscription-name">
                        <LayersOutlinedIcon /> <p>{pkg.name}</p>
                    </Typography>
                </div>

                <div className="subscription-price">
                    <span className="price">${pkg.price}</span>
                    <span className="period">/month</span>
                </div>

                <Typography className="subscription-description">
                    {pkg.description}
                </Typography>
            </div>
        </div>
    );

    return (
        <div className="choose-package">
            <Typography variant="h6" className="package-title">
                Choose Your Package
            </Typography>
            <Typography variant="body2" className="package-subtitle">
                Select the option that best fits your needs
            </Typography>

            <div className="subscription-toggle">
                <div className="toggle-pills">
                    <button
                        type="button"
                        className={`toggle-pill ${!isSubscription ? "active" : ""}`}
                        onClick={() => handleToggleClick(false)}
                    >
                        One-time
                    </button>
                    <button
                        type="button"
                        className={`toggle-pill ${isSubscription ? "active" : ""}`}
                        onClick={() => handleToggleClick(true)}
                    >
                        Subscription
                    </button>
                </div>
            </div>

            <FormControl className="package-form">
                <RadioGroup
                    value={selectedPackage?.id || ""}
                    onChange={handlePackageChange}
                    className="package-group"
                >
                    {isSubscription ? (
                        <div className="subscription-grid">
                            {subscriptionPackages.map(SubscriptionCard)}
                        </div>
                    ) : (
                        <>{currentPackages.map(SubscriptionCard)}</>
                    )}
                </RadioGroup>
            </FormControl>

            <div className="terms-section">
                <Typography variant="body2" className="terms-text">
                    I agree to the{" "}
                    <button type="button" className="terms-link">
                        Terms of Use
                    </button>{" "}
                    and{" "}
                    <button type="button" className="terms-link">
                        Privacy Policy
                    </button>
                </Typography>
            </div>
        </div>
    );
};

ChoosePackage.propTypes = {
    selectedPackage: PropTypes.object,
    setSelectedPackage: PropTypes.func,
};

export default ChoosePackage;
